import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { orderKeys } from '../orderQueryKeys'
import { getOrderHistory } from '../orderEndpoints'
import { parseOrderHistory } from '../orderParser'

const RECENT_ORDERS_LIMIT = 50

/**
 * The newest 50 orders, one page. The holdings API doesn't carry the order
 * behind a holding, so the holding page finds it here by offering id.
 */
export function useRecentOrdersQuery(enabled: MaybeRefOrGetter<boolean> = true) {
  return useQuery({
    queryKey: orderKeys.recentOrders(),
    queryFn: () =>
      getOrderHistory({ page: 1, limit: RECENT_ORDERS_LIMIT, sort: 'newest_first' }).then(
        (response) => parseOrderHistory(response).rows,
      ),
    enabled: () => Boolean(toValue(enabled)),
  })
}
